import { AltroSoggetto } from './altro-soggetto';
import { Model } from './model';

export class TipoAltroSoggetto extends Model {
  static apiUrl: string = "tipi_altri_soggetti";

  nome: string;

  altri_soggetti: AltroSoggetto[];


  deserialize(input: any): TipoAltroSoggetto {
    let retV: TipoAltroSoggetto = new TipoAltroSoggetto();
    retV = super.deserialize(input) as TipoAltroSoggetto;

    if (input?.altri_soggetti) {
      retV.altri_soggetti = input.altri_soggetti.map(v => new AltroSoggetto().deserialize(v));
    }

    return retV;
  }

}
